import { Close } from '@mui/icons-material'
import { Box, Button, Modal, TextareaAutosize } from '@mui/material'
import useStyles from './styles'

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  height: 'auto',
  maxHeight: '14.5rem',
  width: '27.75rem',
  maxWidth: '27.75rem',
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: '0.35rem',
  border: 'none',
  outline: 'none',
  padding: '1rem',
  display: 'flex',
  flexDirection: 'column',

  '& h1': {
    color: '#191C1A',
    fontFamily: 'Sora',
    fontSize: '1.25rem',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '2rem',
    margin: 0,
  },
}

interface IStoreSelectModal {
  open: boolean
  onClose: () => void
  name: string
}

const StoreSelectModal = ({ onClose, open, name }: IStoreSelectModal) => {
  const classes = useStyles()

  return (
    <Modal
      open={open}
      onClose={onClose}
    >
      <Box sx={style}>
        <div className={classes.header}>
          <h1>Solicitar informações</h1>
          <Close
            className={classes.closeIcon}
            onClick={onClose}
          />
        </div>

        <TextareaAutosize
          value={`Olá corretor(a), gostaria de saber mais sobre os produtos do(a) ${name}.`}
          minRows={2}
          readOnly
        />

        <div className={classes.actionBtn}>
          <Button
            variant='contained'
            className={classes.btn}
            onClick={onClose}
          >
            Enviar ao corretor(a)
          </Button>
        </div>
      </Box>
    </Modal>
  )
}

export default StoreSelectModal
